import { render, staticRenderFns } from "./StarshipsEquipment.vue?vue&type=template&id=037889e6&lang=pug&"
import script from "./StarshipsEquipment.vue?vue&type=script&lang=ts&"
export * from "./StarshipsEquipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports